export default [
  'mdiDatabase',
  'mdiNas',
  'mdiFolder',
  'mdiFolderOutline',
  'mdiFile',
  'mdiFileOutline',
  'mdiTable',
  'mdiChartArc',
  'mdiChartBar',
  'mdiChartBarStacked',
  'mdiChartBellCurveCumulative',
  'mdiChartLine',
  'mdiChartPie',
  'mdiChartScatterPlot',
  'mdiFileChart',
  'mdiFileChartOutline',
];
